module.exports = __webpack_public_path__ + "img/logo.e232d9bc.png";